export class LangGlobalsDE{
  public static translateSendBtn = 'Senden';
  public static translateMsgLabel = 'Nachricht';
  public static translateAdditionalLabel = 'Firma*';
  public static translateNameLabel = 'Name*';
  public static translatePolicy = '* Bitte beachten Sie unsere Datenschutzbestimmungen';
  public static translateUaqHeadlineLabel = 'Stellen Sie hier Ihre Frage';
  public static translateDatapolicy = 'Datenschutz';
  public static translateImprint = 'Impressum';
  public static translateTechInfo = 'Technik Info';
  public static translateSendmail = 'Im Falle einer Störung senden Sie bitte eine Nachricht an';
  public static translateBtnPresentation = 'Präsentation';
  public static translateBtnQuestions = 'Fragen';
  public static translateCurSlide = 'Aktuelle Folie';
  public static translateSlide = 'Folien';
  public static translateQuestions = 'Fragen';
  public static translateQuestion = 'Frage';
  public static translateNoUserSeeQuestionsQnA = "Q & A";
  public static translateNoUserVoteQuestionsSendQuestions = "Senden Sie uns Ihre Fragen.";
  public static translateNoUserSeeQuestionsSendQuestions = "Senden Sie uns Ihre Fragen. Lesen Sie hier während des Live-Streamings weitere eingegangene Fragen.";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "Bitte senden Sie uns weitere Fragen und nutzen Sie das";
  public static translateNoUserSeeQuestionsSendAdditionalQuestionsBold = "Abstimmungstool.";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "Stimmen Sie ab während des Live-Streamings. \"Daumen hoch\" priorisiert eine Frage.";
  public static translateQuestionsFixed = 'Fragen';
  public static translateTotal = 'total';
  public static translateTo = 'bis';
  public static translateParticipants = 'Teilnehmende';
  public static translateSlideHistory = 'Folienverlauf';
  public static translateYour = 'Ihre';
  public static translateChapter = 'Kapitel';
  public static translateqSuccess = 'Ihr Frage wurde erfolgreich übermittelt';
  public static translateqError = 'Bitte geben Sie einen Fragetext ein';
  public static translateUsername = 'Benutzername';
  public static translateEmail = 'E-Mail';
  public static translateSendLink = 'Link senden';
  public static translatePassword = 'Passwort';
  public static translatePWRequest = 'Um am Live-Stream teilzunehmen, loggen Sie sich bitte mit Ihren Login-Daten ein.';
  public static translateEmailRequest = 'Um am Live-Streaming teilzunehmen geben Sie bitte zunächst Ihre Mail-Adresse an und bestätigen Sie dann Ihre Eingabe. Anschließend erhalten Sie eine Mail von uns.';
  public static translatePWSuccess = 'Login erfolgreich';
  public static translatePWError = 'Login fehlgeschlagen';
  public static translateNoPW = 'Bitte geben Sie ein Passwort ein';
  public static translatePWtooShort = 'Das eingegebene Passwort muss mindestens sechs Zeichen lang sein';
  public static translateNoUsername = 'Bitte geben Sie einen Benutzernamen ein';
  public static translateBtnLogin = 'Anmelden';
  public static translateEmailSendConfirmation = 'Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Bitte prüfen Sie Ihr Postfach und klicken Sie auf den dort enthaltenen Link, um sich auf der Event-Seite einzuloggen.';
  public static translateBtnLogout = 'Abmelden';
  public static translateLoggedInAs = 'Angemeldet als';
  public static translateEmailSubject = 'Live-Streaming - Meldung einer Störung';
  public static translateStrawpollTitle = 'Abstimmung';
  public static translateStrawpollResults = 'Abstimmungsergebnis';
  public static translateStrawpollYourVote = 'Vielen Dank für Ihre Stimme. Sie haben für';
  public static translateStrawpollVoted = ' abgestimmt.';
  public static translateStrawpollResultDefer = 'Die Ergebnisse werden demnächst veröffentlicht';
  public static translateStrawpollClick = 'Bestätigen Sie Ihre Wahl';
  public static translateStrawpollFailed = 'Abstimmung fehlgeschlagen. Bitte wählen Sie eine der Optionen aus!';
  public static translateChoice = 'Ihre Wahl';
  public static translateResult = 'Ergebnisse';
  public static translatePollTitle = 'Umfrage';
  public static translatePollNew = 'Neu';
  public static translatePollMultiple = 'Mehrere Antworten möglich';
  public static translatePollMaxChoices = 'Bis zu {n} Antworten möglich';
  public static translatePollThanks = 'Vielen Dank für Ihre Stimme.';
  public static translatePollClosed = 'Die Abstimmung ist beendet.';
  public static translatePollVotes = 'Stimmen';
  public static translatePollPast = 'Frühere Umfragen';
  public static translatePollError = 'Ihre Stimme konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.';
  public static translatePollLive = 'Live';
  public static translatePollEnded = 'Beendet';
  public static translatePollScaleHint = 'Ziehen Sie den Regler oder tippen Sie auf einen Wert.';
  public static translatePollAverage = 'Durchschnitt';
  public static translatePollSeriesProgress = 'Frage {n} von {total}';
  public static translatePollSeriesNext = 'Die nächste Frage folgt gleich.';
  public static translatePollEmptyTitle = 'Noch keine Umfrage';
  public static translatePollEmptyText = 'Sobald eine Umfrage startet, erscheint sie hier – ohne neu zu laden';
  public static translatePollVodEmptyText = 'Umfragen erscheinen an der Stelle im Video, an der sie gestellt wurden';
  public static translatePollVodResultLater = 'Das Ergebnis folgt später im Video';
  public static translatePollSkip = 'Überspringen';
  public static translatePollSkipped = 'Übersprungen';
  public static translatePollTextPlaceholder = 'Ihre Antwort …';
  public static translatePollYourAnswer = 'Ihre Antwort';
  public static translatePollSeries = 'Fragenreihe';
  public static translatePollPrev = 'Vorherige Frage';
  public static translatePollNextQuestion = 'Nächste Frage';
  public static translateVoteNow = 'Stimmen Sie ab!';
  public static translateVoteInformation = 'Eingegangene Fragen';
  public static translateVoteCollapse = 'Fragenabstimmung';
  public static translateMediaLibraryShort = 'Mediathek';
  public static translateMediaLibraryLong = 'Dashboard der Mediathek';
  public static translateSyncDesctiption = 'Klicken, um die manuelle Navigation durch die Fragen/Kapitel zu beenden. Diese folgen dann wieder automatisch dem abgespielten Video.';
  public static translateFurtherEvents = 'weitere Events';
  public static translateEventDescription ="Eventbeschreibung"
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='Beliebt';
  public static translateLatest ='Zuletzt';
  public static translateLivePosterTextOne='Live-Stream starten?'
  public static translateLivePosterTextTwo='Bitte klicken Sie auf den Play-Button'
  public static translateVote='Abstimmen';
}
export class LangGlobalsEN{
  public static translateSendBtn = 'Send';
  public static translateMsgLabel = 'Message';
  public static translateAdditionalLabel = 'Location*';
  public static translateNameLabel = 'Name*';
  public static translatePolicy = '* Please note our privacy policy';
  public static translateUaqHeadlineLabel = 'Ask your questions';
  public static translateDatapolicy = 'Data policy';
  public static translateImprint = 'Imprint';
  public static translateTechInfo = 'Technical info';
  public static translateSendmail = 'In case of a disturbance, please send a message to';
  public static translateBtnPresentation = 'Presentation';
  public static translateBtnQuestions = 'questions';
  public static translateCurSlide = 'Current slide';
  public static translateSlide = 'Slides';
  public static translateQuestions = 'questions';
  public static translateQuestion = 'question';
  public static translateQuestionsFixed = 'questions';
  public static translateTo = '-';
  public static translateNoUserSeeQuestionsQnA = "Q & A";
  public static translateNoUserVoteQuestionsSendQuestions = "Send us your questions.";
  public static translateNoUserSeeQuestionsSendQuestions = "Send us your questions. Read more questions we’ve received here during the live stream.";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "Please send us further questions and make use of the";
  public static translateNoUserSeeQuestionsSendAdditionalQuestionsBold = "voting tool.";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "Vote during the live stream. A 'thumbs up' prioritises a question.";
  public static translateParticipants = 'Participants';
  public static translateSlideHistory = 'Slide history';
  public static translateYour = 'Your';
  public static translateChapter = 'Chapters';
  public static translateqSuccess = 'Your question has been received';
  public static translateqError = 'Please enter a question.';
  public static translateUsername = 'Username';
  public static translateEmail = 'E-Mail';
  public static translateSendLink = 'Send link';
  public static translatePassword = 'Password';
  public static translatePWRequest = 'Please use your login credentials to access this event';
  public static translatePWSuccess = 'Login successful';
  public static translateEmailRequest = 'To participate in the live streaming, please first enter your email address and then confirm your entry. You will then receive an email from us.';
  public static translatePWError = 'Login failed';
  public static translateNoPW = 'Please enter a password';
  public static translatePWtooShort = 'Password must be at least 6 characters';
  public static translateNoUsername = 'Username is required';
  public static translateBtnLogin = 'Login';
  public static translateEmailSendConfirmation = 'We have sent you a confirmation email. Please check your inbox and click on the link provided to log in to the event page.';
  public static translateBtnLogout = 'Logout';
  public static translateLoggedInAs = 'Logged in as';
  public static translateEmailSubject = 'Live-Streaming - Reporting a malfunction';
  public static translateStrawpollTitle = 'Strawpoll';
  public static translateStrawpollResults = 'Strawpolling Result';
  public static translateStrawpollYourVote = 'Thank you for your vote. You voted';
  public static translateStrawpollVoted = 'voted.';
  public static translateStrawpollResultDefer = 'Strawpoll Results will be published soon';
  public static translateStrawpollClick = 'Confirm your choice';
  public static translateStrawpollFailed = 'Voting failed. Please select one of the options above!';
  public static translateChoice = 'Your Choice';
  public static translateResult = 'Result';
  public static translatePollTitle = 'Poll';
  public static translatePollNew = 'New';
  public static translatePollMultiple = 'Multiple answers possible';
  public static translatePollMaxChoices = 'Up to {n} answers possible';
  public static translatePollThanks = 'Thank you for your vote.';
  public static translatePollClosed = 'Voting has closed.';
  public static translatePollVotes = 'votes';
  public static translatePollPast = 'Previous polls';
  public static translatePollError = 'Your vote could not be saved. Please try again.';
  public static translatePollLive = 'Live';
  public static translatePollEnded = 'Closed';
  public static translatePollScaleHint = 'Drag the slider or tap a value.';
  public static translatePollAverage = 'Average';
  public static translatePollSeriesProgress = 'Question {n} of {total}';
  public static translatePollSeriesNext = 'The next question follows shortly.';
  public static translatePollEmptyTitle = 'No poll yet';
  public static translatePollEmptyText = 'As soon as a poll starts, it will appear here – no need to reload';
  public static translatePollVodEmptyText = 'Polls appear at the point in the video where they were asked';
  public static translatePollVodResultLater = 'The result follows later in the video';
  public static translatePollSkip = 'Skip';
  public static translatePollSkipped = 'Skipped';
  public static translatePollTextPlaceholder = 'Your answer …';
  public static translatePollYourAnswer = 'Your answer';
  public static translatePollSeries = 'Question series';
  public static translatePollPrev = 'Previous question';
  public static translatePollNextQuestion = 'Next question';
  public static translateVoteNow = 'Vote now!';
  public static translateVoteInformation = 'Questions received';
  public static translateVoteCollapse = 'Question poll';
  public static translateMediaLibraryShort = 'Media library';
  public static translateMediaLibraryLong = 'Media library dashboard';
  public static translateSyncDesctiption = 'Click to stop manually navigating through the questions/chapters. These will then automatically follow the playing video again.';
  public static translateFurtherEvents = 'Further events';
  public static translateEventDescription ="Event description";
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='Popular';
  public static translateLatest ='Latest';
  public static translateLivePosterTextOne='Please click the play button'
  public static translateLivePosterTextTwo='to start the stream.'
  public static translateVote='Vote';
}
export class LangGlobalsNL{
  public static translateSendBtn = 'Zenden';
  public static translateMsgLabel = 'Bericht';
  public static translateAdditionalLabel = 'Firma*';
  public static translateNameLabel = 'Naam*';
  public static translatePolicy = '* Let op ons privacybeleid';
  public static translateUaqHeadlineLabel = 'Stel hier uw vraag';
  public static translateDatapolicy = 'Gegevensbescherming';
  public static translateImprint = 'Imprint';
  public static translateTechInfo = 'Techniek Info';
  public static translateSendmail = 'In geval van een storing kunt u hier een bericht sturen';
  public static translateBtnPresentation = 'Presentatie';
  public static translateBtnQuestions = 'Vragen';
  public static translateCurSlide = 'Actuele presentatie dia';
  public static translateSlide = 'Presentatie dia';
  public static translateQuestions = 'Vragen';
  public static translateQuestion = 'Vraag';
  public static translateNoUserSeeQuestionsQnA = "Vragen & Antwoorden";
  public static translateNoUserVoteQuestionsSendQuestions = "Stuur ons uw vragen en maak gebruik van het stemsysteem.";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "Stuur ons alstublieft meer vragen en maak gebruik van het";
  public static translateNoUserSeeQuestionsSendAdditionalQuestionsBold = "stemsysteem.";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "Hiermee kunt u <b>prioriteiten</b> stellen voor de ingediende vragen door ze een <b>'duim omhoog'</b> te geven.";
  public static translateParticipants = 'Deelnemende';
  public static translateSlideHistory = 'Dialoop';
  public static translateYour = 'Uw';
  public static translateQuestionsFixed = 'Vragen';
  public static translateTo = '-';
  public static translateChapter = 'Hoofdstuk';
  public static translateqSuccess = 'Uw vraag werd met succes ingediend';
  public static translateqError = 'Vul een vraagtekst in';
  public static translateUsername = 'Gebruikersnaam';
  public static translateEmail = 'E-mail';
  public static translateSendLink = 'Link verzenden';
  public static translatePassword = 'Wachtwoord';
  public static translatePWRequest = 'Om deel te nemen aan de livestream, logt u in met uw inloggegevens';
  public static translateEmailRequest = 'Om deel te nemen aan de livestream, voert u eerst uw e-mailadres in en bevestigt u vervolgens uw invoer. U ontvangt dan een e-mail van ons.';
  public static translatePWSuccess = 'Inloggen succesvol';
  public static translatePWError = 'Login fehlgeschlagen';
  public static translateNoPW = 'Kies een wachtwoord';
  public static translatePWtooShort = 'Het ingevoerde wachtwoord moet ten minste zes tekens lang zijn';
  public static translateNoUsername = 'Voer een gebruikersnaam in';
  public static translateBtnLogin = 'Log in';
  public static translateEmailSendConfirmation = 'We hebben u een bevestigingsmail gestuurd. Controleer uw inbox en klik op de link om in te loggen op de evenementpagina.';
  public static translateBtnLogout = 'Log uit';
  public static translateLoggedInAs = 'Geregistreerd als';
  public static translateEmailSubject = 'Live streaming - een storing melden';
  public static translateStrawpollTitle = 'Stemming';
  public static translateStrawpollResults = 'Stemmingsresultaat';
  public static translateStrawpollYourVote = 'Dank u voor uw stem. Je hebt gestemd voor';
  public static translateStrawpollVoted = ' gestemd.';
  public static translateStrawpollResultDefer = 'De resultaten zullen binnenkort worden bekendgemaakt';
  public static translateStrawpollClick = 'Bevestig uw keuze';
  public static translateStrawpollFailed = 'De stemming is mislukt. Kies een van de opties!';
  public static translateChoice = 'Uw keuze';
  public static translateResult = 'Resultaten';
  public static translatePollTitle = 'Peiling';
  public static translatePollNew = 'Nieuw';
  public static translatePollMultiple = 'Meerdere antwoorden mogelijk';
  public static translatePollMaxChoices = 'Maximaal {n} antwoorden mogelijk';
  public static translatePollThanks = 'Dank u voor uw stem.';
  public static translatePollClosed = 'De stemming is gesloten.';
  public static translatePollVotes = 'stemmen';
  public static translatePollPast = 'Eerdere peilingen';
  public static translatePollError = 'Uw stem kon niet worden opgeslagen. Probeer het opnieuw.';
  public static translatePollLive = 'Live';
  public static translatePollEnded = 'Gesloten';
  public static translatePollScaleHint = 'Versleep de schuifregelaar of tik op een waarde.';
  public static translatePollAverage = 'Gemiddelde';
  public static translatePollSeriesProgress = 'Vraag {n} van {total}';
  public static translatePollSeriesNext = 'De volgende vraag volgt zo.';
  public static translatePollEmptyTitle = 'Nog geen peiling';
  public static translatePollEmptyText = 'Zodra een peiling start, verschijnt die hier – opnieuw laden is niet nodig';
  public static translatePollVodEmptyText = 'Peilingen verschijnen op het moment in de video waarop ze werden gesteld';
  public static translatePollVodResultLater = 'Het resultaat volgt later in de video';
  public static translatePollSkip = 'Overslaan';
  public static translatePollSkipped = 'Overgeslagen';
  public static translatePollTextPlaceholder = 'Uw antwoord …';
  public static translatePollYourAnswer = 'Uw antwoord';
  public static translatePollSeries = 'Vragenreeks';
  public static translatePollPrev = 'Vorige vraag';
  public static translatePollNextQuestion = 'Volgende vraag';
  public static translateVoteNow = 'Uw vragen - Stem nu!';
  public static translateVoteInformation = 'Ontvangen vragen';
  public static translateVoteCollapse = 'Stemming over vragen';
  public static translateMediaLibraryShort = 'Mediatheek';
  public static translateMediaLibraryLong = 'Media Bibliotheek dashboard';
  public static translateSyncDesctiption = 'Klik op om de handmatige navigatie door de vragen/hoofdstukken te stoppen. Deze zullen dan automatisch de video volgen die opnieuw wordt afgespeeld.';
  public static translateFurtherEvents = 'verdere gebeurtenissen';
  public static translateEventDescription ="Beschrijving van het evenement"
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='Populair';
  public static translateLatest ='nieuwste';
  public static translateVote='Stem';
}
export class LangGlobalsPT{
  public static translateSendBtn = 'Enviar';
  public static translateMsgLabel = 'Mensagem';
  public static translateAdditionalLabel = 'Empresa*';
  public static translateNameLabel = 'Nome*';
  public static translatePolicy = '* Por favor note a nossa política de privacidade';
  public static translateUaqHeadlineLabel = 'Faça aqui a sua pergunta';
  public static translateDatapolicy = 'Protecção de dados';
  public static translateImprint = 'Impressão';
  public static translateTechInfo = 'Technik Info';
  public static translateSendmail = 'Informação Técnica';
  public static translateBtnPresentation = 'Apresentação';
  public static translateBtnQuestions = 'Perguntas';
  public static translateCurSlide = 'Diapositivo actual';
  public static translateSlide = 'Slides';
  public static translateQuestions = 'Perguntas';
  public static translateQuestion = 'Pergunta';
  public static translateQuestionsFixed = 'Perguntas';
  public static translateTo = '-';
  public static translateNoUserSeeQuestionsQnA = "Perguntas e Respostas";
  public static translateNoUserVoteQuestionsSendQuestions = "Envie-nos suas perguntas e use a <b>ferramenta de votação.</b>";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "Por favor, envie-nos mais perguntas e use a <b>ferramenta de votação.</b>";
  public static translateNoUserSeeQuestionsSendAdditionalQuestionsBold = "ferramenta de votação.";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "Isso permite que você <b>priorize</b> as perguntas que foram submetidas ao dar-lhes um <b>'polegar para cima'.</b>";
  public static translateParticipants = 'Participando';
  public static translateSlideHistory = 'Filme realizado';
  public static translateYour = 'O seu';
  public static translateChapter = 'Capítulo';
  public static translateqSuccess = 'A sua pergunta foi submetida com sucesso';
  public static translateqError = 'Por favor introduza um texto de pergunta';
  public static translateUsername = 'Nome de utilizador';
  public static translateEmail = 'E-mail';
  public static translateSendLink = 'Enviar link';
  public static translatePassword = 'Senha';
  public static translatePWRequest = 'Para participar na transmissão ao vivo, por favor inicie sessão com os seus dados de login';
  public static translateEmailRequest = 'Para participar na transmissão ao vivo, por favor insira primeiro seu endereço de e-mail e confirme sua entrada. Você receberá um e-mail nosso.';
  public static translatePWSuccess = 'Login com sucesso';
  public static translatePWError = 'Login falhou';
  public static translateNoPW = 'Por favor introduza uma palavra-passe';
  public static translatePWtooShort = 'Por favor introduza uma palavra-passe';
  public static translateNoUsername = 'Bitte geben Sie einen Benutzernamen ein';
  public static translateBtnLogin = 'Iniciar Sessão';
  public static translateEmailSendConfirmation = 'Enviámos-lhe um e-mail de confirmação. Por favor, verifique a sua caixa de entrada e clique no link fornecido para fazer login na página do evento.';
  public static translateBtnLogout = 'Terminar sessão';
  public static translateLoggedInAs = 'Registado como';
  public static translateEmailSubject = 'Live streaming - reportar uma avaria';
  public static translateStrawpollTitle = 'Votação';
  public static translateStrawpollResults = 'Resultado da votação';
  public static translateStrawpollYourVote = 'Obrigado pelo vosso voto. Votou em';
  public static translateStrawpollVoted = ' coordenado.';
  public static translateStrawpollResultDefer = 'Os resultados serão publicados em breve';
  public static translateStrawpollClick = 'Confirme a sua escolha';
  public static translateStrawpollFailed = 'A reconciliação falhou. Por favor, seleccione uma das opções!';
  public static translateChoice = 'A sua escolha';
  public static translateResult = 'Resultados';
  public static translatePollTitle = 'Sondagem';
  public static translatePollNew = 'Novo';
  public static translatePollMultiple = 'Várias respostas possíveis';
  public static translatePollMaxChoices = 'Até {n} respostas possíveis';
  public static translatePollThanks = 'Obrigado pelo seu voto.';
  public static translatePollClosed = 'A votação foi encerrada.';
  public static translatePollVotes = 'votos';
  public static translatePollPast = 'Sondagens anteriores';
  public static translatePollError = 'Não foi possível guardar o seu voto. Tente novamente.';
  public static translatePollLive = 'Ao vivo';
  public static translatePollEnded = 'Encerrada';
  public static translatePollScaleHint = 'Arraste o controle deslizante ou toque num valor.';
  public static translatePollAverage = 'Média';
  public static translatePollSeriesProgress = 'Pergunta {n} de {total}';
  public static translatePollSeriesNext = 'A próxima pergunta segue em breve.';
  public static translatePollEmptyTitle = 'Ainda não há sondagem';
  public static translatePollEmptyText = 'Assim que uma sondagem começar, aparecerá aqui – sem necessidade de recarregar';
  public static translatePollVodEmptyText = 'As sondagens aparecem no momento do vídeo em que foram feitas';
  public static translatePollVodResultLater = 'O resultado aparece mais adiante no vídeo';
  public static translatePollSkip = 'Saltar';
  public static translatePollSkipped = 'Saltada';
  public static translatePollTextPlaceholder = 'A sua resposta …';
  public static translatePollYourAnswer = 'A sua resposta';
  public static translatePollSeries = 'Série de perguntas';
  public static translatePollPrev = 'Pergunta anterior';
  public static translatePollNextQuestion = 'Próxima pergunta';
  public static translateVoteNow = 'Vote!';
  public static translateVoteInformation = 'Eingegangene Fragen';
  public static translateVoteCollapse = 'Perguntas recebidas';
  public static translateMediaLibraryShort = 'Mediateca';
  public static translateMediaLibraryLong = 'Painel da biblioteca multimédia';
  public static translateSyncDesctiption = 'Clique para parar de navegar manualmente através das perguntas/capítulos. Estes seguirão então automaticamente o vídeo a ser reproduzido novamente.';
  public static translateFurtherEvents = 'outros eventos';
  public static translateEventDescription ="Descrição do evento"
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='Popular';
  public static translateLatest ='mais recente';
  public static translateVote='Votar';
}
export class LangGlobalsES{
  public static translateSendBtn = 'Enviar';
  public static translateMsgLabel = 'Mensaje';
  public static translateAdditionalLabel = 'Ubicación*';
  public static translateNameLabel = 'Nombre*';
  public static translatePolicy = '* Tenga en cuenta nuestra política de privacidad';
  public static translateUaqHeadlineLabel = 'Haga sus preguntas';
  public static translateDatapolicy = 'Política de datos';
  public static translateImprint = 'Pie de imprenta';
  public static translateTechInfo = 'Información técnica';
  public static translateSendmail = 'En caso de que se produzcan molestias, le rogamos que envíe un mensaje a';
  public static translateEmailRequest = 'Para participar en la transmisión en vivo, por favor ingrese primero su dirección de correo electrónico y luego confirme su entrada. Luego recibirá un correo electrónico nuestro.';
  public static translateBtnPresentation = 'Presentación';
  public static translateBtnQuestions = 'Preguntas';
  public static translateQuestionsFixed = 'Preguntas';
  public static translateTo = '-';
  public static translateCurSlide = 'Diapositiva actual';
  public static translateSlide = 'Diapositivas';
  public static translateQuestions = 'Preguntas';
  public static translateQuestion = 'Pregunta';
  public static translateNoUserSeeQuestionsQnA = "Preguntas y Respuestas";
  public static translateNoUserVoteQuestionsSendQuestions = "Envíenos sus preguntas y utilice la <b>herramienta de votación.</b>";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "Por favor, envíenos más preguntas y utilice la <b>herramienta de votación.</b>";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "Esto le permite <b>priorizar</b> las preguntas que han sido presentadas dándoles un <b>'pulgar hacia arriba'.</b>";
  public static translateParticipants = 'Participantes';
  public static translateSlideHistory = 'Historia de las diapositivas';
  public static translateYour = 'Su';
  public static translateChapter = 'Capítulo';
  public static translateqSuccess = 'Su pregunta ha sido recibida';
  public static translateqError = 'Por favor, introduzca una pregunta.';
  public static translateUsername = 'Nombre de usuario';
  public static translateEmail = 'E-mail';
  public static translateSendLink = 'Enviar link';
  public static translatePassword = 'Contraseña';
  public static translatePWRequest = 'Utilice sus credenciales de acceso para acceder a este evento';
  public static translatePWSuccess = 'Inicio de sesión con éxito';
  public static translatePWError = 'Fallo en el inicio de sesión';
  public static translateNoPW = 'Por favor, introduzca una contraseña';
  public static translatePWtooShort = 'La contraseña debe tener al menos 6 caracteres';
  public static translateNoUsername = 'El nombre de usuario es obligatorio';
  public static translateBtnLogin = 'Inicio de sesión';
  public static translateEmailSendConfirmation = 'Le hemos enviado un correo electrónico de confirmación. Por favor, revise su bandeja de entrada y haga clic en el enlace proporcionado para iniciar sesión en la página del evento.';
  public static translateBtnLogout = 'cierre de sesión';
  public static translateLoggedInAs = 'Conectado como';
  public static translateEmailSubject = 'Live-Streaming - Informar de una avería';
  public static translateStrawpollTitle = 'Collar de paja';
  public static translateStrawpollResults = 'Resultado de la votación a pie de urna';
  public static translateStrawpollYourVote = 'Gracias por su voto. Has votado';
  public static translateStrawpollVoted = 'votó.';
  public static translateStrawpollResultDefer = 'Los resultados de la encuesta se publicarán en breve';
  public static translateStrawpollClick = 'Confirme su elección';
  public static translateStrawpollFailed = 'La votación ha fallado. Por favor, seleccione una de las opciones anteriores.';
  public static translateChoice = 'Su elección';
  public static translateResult = 'Resultado';
  public static translatePollTitle = 'Encuesta';
  public static translatePollNew = 'Nuevo';
  public static translatePollMultiple = 'Se pueden elegir varias respuestas';
  public static translatePollMaxChoices = 'Hasta {n} respuestas posibles';
  public static translatePollThanks = 'Gracias por su voto.';
  public static translatePollClosed = 'La votación ha finalizado.';
  public static translatePollVotes = 'votos';
  public static translatePollPast = 'Encuestas anteriores';
  public static translatePollError = 'No se pudo guardar su voto. Inténtelo de nuevo.';
  public static translatePollLive = 'En vivo';
  public static translatePollEnded = 'Finalizada';
  public static translatePollScaleHint = 'Arrastre el control deslizante o toque un valor.';
  public static translatePollAverage = 'Media';
  public static translatePollSeriesProgress = 'Pregunta {n} de {total}';
  public static translatePollSeriesNext = 'La siguiente pregunta llegará en breve.';
  public static translatePollEmptyTitle = 'Aún no hay encuesta';
  public static translatePollEmptyText = 'En cuanto empiece una encuesta, aparecerá aquí, sin necesidad de recargar';
  public static translatePollVodEmptyText = 'Las encuestas aparecen en el momento del vídeo en que se plantearon';
  public static translatePollVodResultLater = 'El resultado aparece más adelante en el vídeo';
  public static translatePollSkip = 'Omitir';
  public static translatePollSkipped = 'Omitida';
  public static translatePollTextPlaceholder = 'Su respuesta …';
  public static translatePollYourAnswer = 'Su respuesta';
  public static translatePollSeries = 'Serie de preguntas';
  public static translatePollPrev = 'Pregunta anterior';
  public static translatePollNextQuestion = 'Siguiente pregunta';
  public static translateVoteNow = '¡Vota ahora!';
  public static translateVoteInformation = 'Preguntas recibidas';
  public static translateVoteCollapse = 'Pregunta de la encuesta';
  public static translateMediaLibraryShort = 'Mediateca';
  public static translateMediaLibraryLong = 'Tablero de la mediateca';
  public static translateSyncDesctiption = 'Haga clic para dejar de navegar manualmente por las preguntas/capítulos. Éstas volverán a seguir automáticamente el vídeo en reproducción.';
  public static translateFurtherEvents = 'Otros eventos';
  public static translateEventDescription ="Descripción del evento"
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='popular';
  public static translateLatest ='último';
  public static translateVote='Votar';
}
export class LangGlobalsCN{
  public static translateSendBtn = '发送';
  public static translateMsgLabel = '留言';
  public static translateAdditionalLabel = '地点*';
  public static translateNameLabel = '命名*';
  public static translatePolicy = '* 请注意我们的隐私政策';
  public static translateUaqHeadlineLabel = '提出您的问题';
  public static translateDatapolicy = '数据政策';
  public static translateImprint = '版本说明';
  public static translateTechInfo = '技术信息';
  public static translateSendmail = '如遇干扰，请发信息至';
  public static translateBtnPresentation = '演示文稿';
  public static translateBtnQuestions = '问题';
  public static translateCurSlide = '当前幻灯片';
  public static translateSlide = '幻灯片';
  public static translateQuestions = '问题';
  public static translateQuestion = '问题';
  public static translateQuestionsFixed = '问题';
  public static translateTo = '-';
  public static translateNoUserSeeQuestionsQnA = "问答";
  public static translateNoUserVoteQuestionsSendQuestions = "请向我们提交您的问题，并使用 <b>投票工具。</b>";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "请向我们提交更多问题，并使用 <b>投票工具。</b>";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "这样您可以通过 <b>点赞</b> 来 <b>优先处理</b> 已提交的问题。";
  public static translateParticipants = '参与者';
  public static translateSlideHistory = '幻灯片历史';
  public static translateYour = '你的';
  public static translateChapter = '章节';
  public static translateqSuccess = '您的问题已收到';
  public static translateqError = '请输入一个问题。';
  public static translateUsername = '帐号';
  public static translateEmail = '电子邮件';
  public static translateSendLink = '发送链接';
  public static translatePassword = '密码';
  public static translatePWRequest = '请使用您的登录凭证来访问此活动';
  public static translateEmailRequest = '要参加直播，请先输入您的电子邮件地址，然后确认您的输入。您将收到我们的电子邮件。';
  public static translatePWSuccess = '登录成功';
  public static translatePWError = '登录失败';
  public static translateNoPW = '请输入密码';
  public static translatePWtooShort = '密码必须至少有6个字符';
  public static translateNoUsername = '用户名是必需的';
  public static translateBtnLogin = '登录';
  public static translateEmailSendConfirmation = '我们已向您发送了一封确认电子邮件。请检查您的收件箱并点击提供的链接以登录到活动页面。';
  public static translateBtnLogout = '登出';
  public static translateLoggedInAs = '登录为';
  public static translateEmailSubject = '直播--报告故障';
  public static translateStrawpollTitle = '稻草人';
  public static translateStrawpollResults = '抽签结果';
  public static translateStrawpollYourVote = '感谢你的投票。您的投票';
  public static translateStrawpollVoted = '经表决通过.';
  public static translateStrawpollResultDefer = '抽样调查的结果将很快公布';
  public static translateStrawpollClick = '确认您的选择';
  public static translateStrawpollFailed = '投票失败。请从上面的选项中选择一个!';
  public static translateChoice = '您的选择';
  public static translateResult = '结果';
  public static translatePollTitle = '投票';
  public static translatePollNew = '新';
  public static translatePollMultiple = '可多选';
  public static translatePollMaxChoices = '最多可选 {n} 项';
  public static translatePollThanks = '感谢您的投票。';
  public static translatePollClosed = '投票已结束。';
  public static translatePollVotes = '票';
  public static translatePollPast = '以往投票';
  public static translatePollError = '您的投票未能保存，请重试。';
  public static translatePollLive = '进行中';
  public static translatePollEnded = '已结束';
  public static translatePollScaleHint = '拖动滑块或点击一个数值。';
  public static translatePollAverage = '平均值';
  public static translatePollSeriesProgress = '第 {n} 题，共 {total} 题';
  public static translatePollSeriesNext = '下一题即将开始。';
  public static translatePollEmptyTitle = '暂无投票';
  public static translatePollEmptyText = '投票开始后会自动显示在这里，无需刷新页面';
  public static translatePollVodEmptyText = '投票会在视频中提出它的位置出现';
  public static translatePollVodResultLater = '结果将在视频稍后部分显示';
  public static translatePollSkip = '跳过';
  public static translatePollSkipped = '已跳过';
  public static translatePollTextPlaceholder = '您的回答…';
  public static translatePollYourAnswer = '您的回答';
  public static translatePollSeries = '问题系列';
  public static translatePollPrev = '上一题';
  public static translatePollNextQuestion = '下一题';
  public static translateVoteNow = '现在就投票吧!';
  public static translateVoteInformation = '收到的问题';
  public static translateVoteCollapse = '问题投票';
  public static translateMediaLibraryShort = '媒体库';
  public static translateMediaLibraryLong = '媒体库仪表板';
  public static translateSyncDesctiption = '点击停止手动浏览问题/章节。然后，这些将自动再次跟随播放的视频。';
  public static translateFurtherEvents = '进一步的活动';
  public static translateEventDescription ="事件描述";
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='熱門';
  public static translateLatest ='最新';
  public static translateVote='投票';
}
export class LangGlobalsJP{
  public static translateSendBtn = '送信';
  public static translateMsgLabel = 'メッセージ';
  public static translateAdditionalLabel = '会社概要*';
  public static translateNameLabel = '名称*';
  public static translatePolicy = '* 個人情報保護方針にご注意ください';
  public static translateUaqHeadlineLabel = 'ご質問はこちら';
  public static translateDatapolicy = 'データ保護';
  public static translateImprint = 'インプリント';
  public static translateTechInfo = '技術情報';
  public static translateSendmail = '障害が発生した場合、こちらからメッセージを送ることができます。';
  public static translateBtnPresentation = 'プレゼンテーション';
  public static translateBtnQuestions = 'ご質問';
  public static translateCurSlide = '現在のスライド';
  public static translateSlide = 'スライド';
  public static translateQuestions = 'ご質問';
  public static translateQuestion = '質問';
  public static translateQuestionsFixed = 'ご質問';
  public static translateTo = '-';
  public static translateNoUserSeeQuestionsQnA = "質問と回答";
  public static translateNoUserVoteQuestionsSendQuestions = "ご質問をお送りいただき、 <b>投票ツール</b> をご利用ください。";
  public static translateNoUserSeeQuestionsSendAdditionalQuestions = "さらにご質問をお送りいただき、 <b>投票ツール</b> をご利用ください。";
  public static translateNoUserVoteQuestionsGiveThumbsUp = "これにより、送信された質問に <b>'いいね'</b> を与えることで <b>優先順位を付ける</b> ことができます。";
  public static translateParticipants = '参加中';
  public static translateSlideHistory = '映画上映';
  public static translateYour = 'あなたの';
  public static translateChapter = '章';
  public static translateqSuccess = 'ご質問は正常に送信されました';
  public static translateqError = '質問テキストを入力してください';
  public static translateUsername = 'ユーザー名';
  public static translateEmail = 'Eメール';
  public static translateSendLink = 'リンクを送る';
  public static translatePassword = 'パスワード';
  public static translatePWRequest = 'ライブ配信に参加するには、ログインデータでログインしてください';
  public static translateEmailRequest = 'ライブストリーミングに参加するには、まずメールアドレスを入力し、入力を確認してください。 その後、私たちからメールが届きます。';
  public static translatePWSuccess = 'ログイン成功';
  public static translatePWError = 'ログインに失敗しました';
  public static translateNoPW = 'パスワードを入力してください';
  public static translatePWtooShort = '入力するパスワードは6文字以上でなければならない';
  public static translateNoUsername = 'ユーザー名を入力してください';
  public static translateBtnLogin = 'ログイン';
  public static translateEmailSendConfirmation = '確認メールをお送りしました。受信トレイを確認し、提供されたリンクをクリックしてイベントページにログインしてください。';
  public static translateBtnLogout = 'ログアウト';
  public static translateLoggedInAs = 'として登録されています';
  public static translateEmailSubject = 'ライブストリーミング - 故障の報告';
  public static translateStrawpollTitle = '投票';
  public static translateStrawpollResults = '投票結果';
  public static translateStrawpollYourVote = '投票ありがとうございました。に投票しました';
  public static translateStrawpollVoted = ' に投票した。';
  public static translateStrawpollResultDefer = '結果は近日中に公開予定です';
  public static translateStrawpollClick = '選択内容を確認する';
  public static translateStrawpollFailed = '和解に失敗。選択してください';
  public static translateChoice = 'あなたの選択';
  public static translateResult = '結果';
  public static translatePollTitle = 'アンケート';
  public static translatePollNew = '新着';
  public static translatePollMultiple = '複数回答可';
  public static translatePollMaxChoices = '最大 {n} 件まで選択可';
  public static translatePollThanks = 'ご投票ありがとうございます。';
  public static translatePollClosed = '投票は終了しました。';
  public static translatePollVotes = '票';
  public static translatePollPast = '過去のアンケート';
  public static translatePollError = '投票を保存できませんでした。もう一度お試しください。';
  public static translatePollLive = 'ライブ';
  public static translatePollEnded = '終了';
  public static translatePollScaleHint = 'スライダーを動かすか、数値をタップしてください。';
  public static translatePollAverage = '平均';
  public static translatePollSeriesProgress = '質問 {n} / {total}';
  public static translatePollSeriesNext = 'まもなく次の質問が表示されます。';
  public static translatePollEmptyTitle = 'アンケートはまだありません';
  public static translatePollEmptyText = 'アンケートが始まると、ここに自動的に表示されます';
  public static translatePollVodEmptyText = 'アンケートは動画内で出題された時点で表示されます';
  public static translatePollVodResultLater = '結果は動画の後半で表示されます';
  public static translatePollSkip = 'スキップ';
  public static translatePollSkipped = 'スキップしました';
  public static translatePollTextPlaceholder = 'ご回答…';
  public static translatePollYourAnswer = 'ご回答';
  public static translatePollSeries = '質問シリーズ';
  public static translatePollPrev = '前の質問';
  public static translatePollNextQuestion = '次の質問';
  public static translateVoteNow = '投票しよう';
  public static translateVoteInformation = '寄せられた質問';
  public static translateVoteCollapse = '質問事項の投票';
  public static translateMediaLibraryShort = 'メディアライブラリ';
  public static translateMediaLibraryLong = 'メディアライブラリーダッシュボード';
  public static translateSyncDesctiption = 'クリックすると、問題/チャプターの手動によるナビゲーションを停止します。これらは、再び再生されるビデオに自動的に追従します。';
  public static translateFurtherEvents = 'その他のイベント';
  public static translateEventDescription ="イベント内容";
  public static translatePolicyName = '';
  public static translatePolicyAdditional = '';
  public static translatePolicyMessage ='';
  public static translatePopular='人気';
  public static translateLatest ='最新';
  public static translateVote='投票';
}
